export class ProfileLiveMediaModel {
  readonly profileImageUsageCounter!: number;
  readonly maxProfileImageCount!: number;
  readonly photosUsageCounter!: number;
  readonly maxPhotosCount!: number;

  constructor(args: ProfileLiveMediaModel) {
    Object.assign(this, args);
  }

  getPhotosQuota(): [number, number] {
    const left = Math.max(this.maxPhotosCount - this.photosUsageCounter, 0);
    return [left, this.maxPhotosCount];
  }

  getProfileImageQuota(): [number, number] {
    const left = Math.max(this.maxProfileImageCount - this.profileImageUsageCounter, 0);
    return [left, this.maxProfileImageCount];
  }
}
